import { create } from 'zustand';

interface MultiMarkPriceState {
  prices: Record<string, number>;
  connect: (symbols: string[]) => void;
}

export const useMultiMarkPriceStore = create<MultiMarkPriceState>((set) => {
  let socket: WebSocket | null = null;
  let currentSymbols: string[] = [];

  const connect = (symbols: string[]) => {
    const cleanSymbols = [...new Set(symbols)].sort();
    const cleanCurrent = [...currentSymbols].sort();

    if (JSON.stringify(cleanSymbols) === JSON.stringify(cleanCurrent)) {
      return;
    }

    currentSymbols = cleanSymbols;

    if (socket) {
      socket.close();
    }

    const streams = cleanSymbols.map((s) => `${s.toLowerCase()}@markPrice`);
    const url = `wss://fstream.binance.com/stream?streams=${streams.join('/')}`;

    socket = new WebSocket(url);

    socket.onopen = () => console.log('WebSocket Opened:', url);

    socket.onmessage = (event) => {
      const { data } = JSON.parse(event.data);
      const symbol = data?.s?.toLowerCase();
      const price = parseFloat(data?.p);

      if (!symbol || isNaN(price)) return;

      set((state) => ({
        prices: {
          ...state.prices,
          [symbol]: price,
        },
      }));
    };

    socket.onerror = (e) => {
      console.error('WebSocket Error:', e);
    };
  };


  return {
    prices: {},
    connect,
  };
});
